// src/utils/fixedBigArray.js
// 直接挂载到window上，全项目可访问，无需导出
window.fixedProcessList = [
  {
    label: "全部",
    value: "全部",
    children: [
      { label: "下料", value: "下料" },
      { label: "包板", value: "包板" },
      { label: "裁布", value: "裁布" },
      { label: "外协", value: "外协" },
      { label: "包装", value: "包装" }
    ]
  }
];

// 可选：多个固定数组统一挂载
window.fixedGlobalData = {
  processList: window.fixedProcessList,
  otherFixedList: [
    /* 其他固定数组 */
  ]
};
